// Static option lists for the Trade Recommendation form.
// Extracted verbatim from TradeRecommendationForm.jsx — values unchanged.

// Category dropdown — the number is stored, the label is shown.
export const tradeRecommendationIdOptions = [
  { value: 1, label: "Buy" },
  { value: 2, label: "Sell" },
];

// Default status choices (used for Status and the Target-status dropdowns).
export const defaultTargetStatusOptions = [
  { value: "Target Hit", label: "Target Hit" },
  { value: "Live", label: "Live" },
  { value: "Stoploss Hit", label: "Stoploss Hit" },
  { value: "Closed", label: "Closed" },
];

// Exit Type dropdown — 1 = Manual, 2 = Auto.
export const exitTypeIdOptions = [
  { value: 1, label: "Manual Exit" },
  { value: 2, label: "Auto Exit" },
];
